import * as React from 'react';

import { Button } from '@acceligentllc/storybook';

import CustomModal from 'af-components/CustomModal';

interface OwnProps {
	modalTitle: string;
	descriptionTitle: React.JSX.Element | null;
	descriptionMessage: React.JSX.Element | null;
	showModal: boolean;
	closeModal: () => void;
}

type Props = OwnProps;

const ActionSuccessModal: React.FC<Props> = (props) => {
	const { closeModal, showModal, modalTitle, descriptionTitle, descriptionMessage } = props;

	return (
		<CustomModal
			className="submit-success-modal"
			showModal={showModal}
			size="md"
		>
			<CustomModal.Header closeModal={closeModal} title={modalTitle} />
			<CustomModal.Body>
				<div className="submit-success-modal__content-title">{descriptionTitle}</div>
				<span className="submit-success-modal__check-icon icon-check_circle text-green" />
				<div className="submit-success-modal__user-message">{descriptionMessage}</div>
			</CustomModal.Body>
			<CustomModal.Footer>
				<Button
					label="Close"
					onClick={closeModal}
					style="secondary"
				/>
			</CustomModal.Footer>
		</CustomModal>
	);
};

export type ActionSuccessModalProps = OwnProps;
export default React.memo(ActionSuccessModal);
